export enum UserStatus {
  Offline,
  Online,
  Playing,
  Unreachable
}
